import React, { Component } from "react";
import { toast } from "react-toastify";
import { Constants } from "../libs/Constants";
import { getList } from "../libs/dbFunctions";
import AdminDashboard from "./AdminDashboard.js";
import EmployeeHome from "./EmployeeHome";
import "./Home.css";
import NonAcceptHome from "./NonAcceptHome.js";

export default class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      report: this.getInvestmentReport(),
      obj: this.getPeriodData("Period"),
    };
  }

  async getPlanDetail() {
    try {
      let planDetail = await getList(
        Constants.dbTypes.PLAN_DETAILS,
        this.props.activeCompany
      );
      if (planDetail && planDetail.length > 0) {
        return planDetail[0];
      }
    } catch (e) {
      toast.error(e);
    }
  }
  getInvestmentReport() {
    return [
      {
        value: (o) => o.duration,
        display: "Time Frame",
      },
      {
        value: (o) => o.currentPrice,
        display: "Current Price",
      },
      {
        value: (o) => o.purchasePrice,
        display: "Purchase Price",
      },
    ];
  }

  getPeriodData(period) {
    let ret = {};
    ret.duration = period;
    ret.currentPrice = 48.52;
    if (period === "Quarter") {
      ret.purchasePrice = "44.25";
    } else if (period === "Year") {
      ret.purchasePrice = "39.25";
    } else {
      ret.purchasePrice = "55.25";
    }
    return ret;
  }

  renderLander() {
    window.scrollTo(0, 0);
    this.props.history.push("/login");
    // return (
    //   <div className="lander">
    //     <h1>TAABL</h1>
    //     <p>Your stock option central</p>
    //   </div>
    // );
  }

  updateView(period) {
    this.setState({
      obj: this.getPeriodData(period),
    });
  }

  renderAdminHome() {
    return <AdminDashboard {...this.props}></AdminDashboard>;
  }

  renderEmployeeHome() {
    if (
      this.props.userObj.zoneinfo !== "self" &&
      !this.props.userObj.acceptTerms
    ) {
      return <NonAcceptHome {...this.props}></NonAcceptHome>;
    } else {
      return <EmployeeHome />;
    }
    return <></>;
  }

  renderHome() {
    window.scrollTo(0, 0);
    return (
      <div>
        {this.props.userObj && this.props.userObj.permission === 0
          ? this.renderEmployeeHome()
          : this.renderAdminHome()}
      </div>
    );
  }

  render() {
    return (
      <div className="bg-body">
        {this.props.isAuthenticated ? this.renderHome() : this.renderLander()}
      </div>
    );
  }
}
